<!-- Start::menu item (lg+) -->
<div class="hidden lg:block">
  <h2 class="fw-bold ps-3" style="font-size: 14px">Mi cuenta</h2>
  <hr class="my-2" style="background-color: #646462" />

  <div>
    <ul>
      @for (link of links; track $index) {
      <li class="ps-3">
        <span class="link" (click)="validarCuenta(link)">{{
          link.label
        }}</span>
      </li>
      }
    </ul>
  </div>

  <div class="ps-3">
    <div>
      <picture style="width: 50px; aspect-ratio: 42/61; position: relative">
        <source srcset="assets/images/mutual_01.webp" type="image/webp" />
        <source srcset="assets/images/mutual_01.png" type="image/png" />
        <img ngSrc="assets/images/mutual_01.png" alt="mutual" fill />
      </picture>
    </div>
  </div>
</div>

<!-- End::menu item (lg+) -->

<!-- Start::menu item (xs, sm y md) -->
<div class="block lg:hidden">
  <div
    class="col-12 py-0"
    data-bs-toggle="collapse"
    data-bs-target="#account"
    [attr.aria-expanded]="terminos"
    aria-controls="account"
  >
    <div class="row">
      <div class="col-8 py-0 flex justify-content-start">
        <h3 class="fw-bold text-center">Mi cuenta</h3>
      </div>
      <div class="col-4 py-0 flex justify-content-end">
        <i class="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  </div>
  <hr class="my-2" style="background-color: #646462" />
  <div
    class="collapse multi-collapse"
    [ngClass]="terminos ? 'show' : ''"
    id="account"
  >
    <ul>
      @for (link of links; track $index) { @if (link.label !== 'Cerrar sesión'
      && usuario) {
      <li class="ps-3">
        <span class="link" (click)="validarCuenta(link)">{{
          link.label
        }}</span>
      </li>
      } }
    </ul>
    <hr class="my-2" style="background-color: #646462" />
  </div>
</div>
<!-- End::menu item (xs, sm y md) -->
